import { CartLinkedEntitlementsSchema, CartProductSchema } from '../../../types';

export interface BillingProfileOption {
  label: string;
  value: string;
}

export type EntitlementItemType = Pick<
  CartProductSchema,
  | 'id'
  | 'productId'
  | 'entitlementNumber'
  | 'inTrial'
  | 'isOrgProduct'
  | 'offeringName'
  | 'isSandbox'
  | 'isFutureDatedSubscription'
  | 'offeringId'
  | 'parentEntitlementId'
> & {
  isChecked: boolean;
  name: string;
  linkedEntitlements: { id: string }[];
  addons: { id: string }[];
  inactiveReason?: string;
};

export enum SelectType {
  SITE = 'site',
  ORG = 'org',
  ENTITLEMENT = 'entitlement',
}

export type CloudSiteOrOrgNameMap = Record<
  string,
  {
    products: any[]; //(any & { isChecked: boolean; linkedEntitlements: CartLinkedEntitlementsSchema[] })[];
    inactiveProducts: any[]; //(any & { isChecked: boolean; linkedEntitlements: CartLinkedEntitlementsSchema[] })[];
    isChecked: boolean;
  }
>;
/**
 *
 * CloudSiteMapGroupedByBillingProfile = [{
 *  billingProfileId: <billing-profile-id>
 *  cloudSiteMap: {
 *    <cloud-site-host-name>: {
 *      products: (any & { isChecked: boolean })[],
 *      isChecked: boolean
 *    }
 *  }
 * }]
 */

export type CloudSiteOrOrgNameMapGroupedByBillingProfile = {
  billingProfileId: string;
  billingProfileName: string;
  cloudSiteOrOrgNameMap: CloudSiteOrOrgNameMap;
}[];

export type ExternalProductsList = {
  id: string;
  transactionAccountId: string;
  cloudSiteId: string;
  cloudSiteHostname: string;
}[];

export enum ExternalProductListFetchStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum EntitlementListWithEmailFetchStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
}
